import '../views/administration/reporting/noReporting.html';
import '../views/administration/reporting/overview.html';

export class ReportingRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state('app.noReportingAccounts', {
            url: '/noReportingAccounts',
            templateUrl: './app/views/administration/reporting/noReporting.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'ACCOUNTS'
            }
        }).state('app.noMovementAccounts', {
            url: '/noMovementAccounts',
            templateUrl: './app/views/administration/reporting/overview.html',
            controller: 'CommonViewController',
            params: {
                pageTitle: 'ACCOUNTS',
                predefinedQuery: 'NON_MOVEMENT_ACCOUNTS'
            }
        }).state('app.noReportingAccountsDelete', {
            url: '/noReportingAccountsDelete',
            templateUrl: './app/views/administration/reporting/confirmation.html',
            controller: 'SendReportingDeleteConfirmationController',
            controllerAs: 'deleteConfirmationController',
            params: {
                pKey: 'accountName',
                restUrl: 'noReportingAccountsDelete',
                pageTitle: 'DELETE_ACCOUNT',
                message: 'CONFIRMATION_DELETE_ACCOUNT'
            }
        }).state('app.noMovementAccountsDelete', {
            url: '/noMovementAccountsDelete',
            templateUrl: './app/views/administration/reporting/confirmation.html',
            controller: 'SendReportingDeleteConfirmationController',
            controllerAs: 'deleteConfirmationController',
            params: {
                pKey: 'accountName',
                restUrl: 'noMovementAccountsDelete',
                pageTitle: 'DELETE_ACCOUNT',
                message: 'CONFIRMATION_DELETE_ACCOUNT'
            }
        });
    }
}
